/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { DateTime } from 'luxon';
import { AlertBar, Text } from '@blend/enterprise-components';

import { remCalc } from 'blb-styles/functions';

export const styles = StyleSheet.create({
  message: {
    marginLeft: remCalc(8),
  },
});

const renderMessage = (): JSX.Element => {
  const date = DateTime.local().toFormat('h:mm ZZZZ, MMMM d');

  return (
    <div className={css(styles.message)} id="unsigned-esign-alertbar-message">
      <Text colorName="NIGHT_90" fontSize="md" weight="bold">
        The borrower has not eSigned the sign ahead closing documents yet
      </Text>
      <Text colorName="NIGHT_90" fontSize="md">
        {' '}
        (as of {date}) <br />
        Please work with the borrower to ensure that these documents are eSigned before the closing appointment.
      </Text>
    </div>
  );
};

/**
 * Returns an Alert Banner notifying Settlement Agents
 * that the borrower has not e-signed Sign Ahead Docs
 * @return {React.ReactNode} Alert Banner DOM Node
 * @function
 */
export const eSignOverviewBanner = (): React.ReactNode => (
  <AlertBar icon="warning" message={renderMessage()} theme="warn" />
);
